<template>
  <div class="assetDetailContent">
    <div class="assetDetailContent-title">
      <div>
        <h3>CONTENT</h3>
      </div>
      <div>
        <neb-button @click="onViewClick">View Original Content</neb-button>
      </div>
    </div>
    <div class="assetDetailContent-content"
      v-html="html || ''"
    ></div>
  </div>
</template>

<script>
export default {
  name: 'AssetDetailContent',

  props: {
    html: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    }
  },

  setup (props) {
    const onViewClick = () => window.open(props.url, '_blank').focus()

    return {
      onViewClick
    }
  }
}
</script>

<style lang="scss">
@import '../Nebula/style.scss';

.assetDetailContent {
  &-title {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 10px;

    h3 {
      font-family: $defaultFont;
      font-size: 14px;
      font-weight: 300;
      color: $slate-grey;
      margin: 0;
    }
  }

  &-content {
    box-sizing: border-box;
    overflow-x: hidden;
    overflow-y: scroll;
    max-height: 700px;
  }
}
</style>
